// extracted by mini-css-extract-plugin
export default {"form":"default_form__GCcPf","content":"default_content__wGyfx","description":"default_description__rYnjR","controls":"default_controls__QSp1C"};